<template>
  <div class="visaflow-container">
    <div class="com-detail-hd">
      <detail-header></detail-header>
    </div>
    <div class="visaflowIndex-container">
      <div class="visaflowIndex-page">
        <div class="visaflowIndex-list">
          <table>
            <tr>
              <th>流程名称</th>
              <th>签证流单号</th>
              <th>当前节点</th>
            </tr>
            <tr
              v-for="item of visaFlowList"
              :key="item.Id"
              class="hover"
              @click="showDetails(item.Id)"
            >
              <td>{{item.Title}}</td>
              <td>{{item.FlowCode}}</td>
              <td
                :style="item.FlowStatus<6?{color:'#3cd190'}:''"
              >{{item.FlowStatus | FlowStatusChange}}</td>
            </tr>
          </table>
        </div>
        <el-pagination
          background
          layout="prev,pager,next"
          prev-text="上一页"
          next-text="下一页"
          :total="total"
          @current-change="pageChange"
          :current-page="pages"
        ></el-pagination>
      </div>

      <detail-aside
        createText="创建新的签证流"
        :imgSrc="imgSrc"
        :IsLogin="IsLogin"
        :CanOperat="CanOperat"
        @open="open"
        @init="init"
      ></detail-aside>

      <d-visaflow v-if="visaflowShow" @closeVf="closeVf" @initVf="init"></d-visaflow>

      <d-vf-details
        v-if="vfDetailsShow"
        :vfDetailsObj="vfDetailsObj"
        :IsLogin="IsLogin"
        :CanOperat="CanOperat"
        :id="id"
        @closeVfDetails="closeVfDetails"
        @showLargePic="showLargePic(arguments)"
        @showVfDetails="showDetails(id)"
        @update="update"
      ></d-vf-details>

      <d-Swiper
        :currentImgList="currentImgList"
        :activeIndex="activeIndex"
        @closeLargePic="closeLargePic"
        v-if="largePicShow"
      ></d-Swiper>

      <d-update
        v-if="dUpdateShow"
        @closeDUpdate="closeDUpdate"
        :id="id"
        :FlowStatus="vfDetailsObj.FlowStatus"
      ></d-update>
    </div>
  </div>
</template>

<script>
import md5 from 'js-md5';

import "../../../../html/pages/originality/visaFlowIndex/visaFlowIndex.scss"

import detailHeader from './components/detailHeader'
import detailAside from './components/detailAside'
import dVisaflow from './components/d-visaflow'
import dVfDetails from './components/d-vfDetails'
import dSwiper from './components/d-swiper'
import dUpdate from './components/d-update'

import { GetVisaflowInfo, GetVisaflowDetails } from '../../../../api/index'

export default {
  name: 'visaFlowIndex',
  data() {
    return {
      visaFlowList: [],
      imgSrc: require('../../../../html/pages/originality/visaFlowIndex/images/create.png'),
      visaflowShow: false,
      vfDetailsShow: false,
      vfDetailsObj: {},
      IsLogin: false,
      CanOperat: false,
      id: '',
      currentImgList: [],
      activeIndex: '',
      largePicShow: false,
      dUpdateShow: false,
      total: 1,
      pages: 1
    }
  },
  components: {
    detailHeader,
    detailAside,
    dVisaflow,
    dVfDetails,
    dSwiper,
    dUpdate
  },
  beforeRouteUpdate(to,from,next){
    next();
    this.init();
  },
  methods: {
    pageChange(pageIndex) {
      this.$router.push(`/originality/visaflowindex/${this.$route.params.id}/${pageIndex}`)
    },
    async init() {
      let res = await GetVisaflowInfo({
        forumId: this.$route.params.id,
        pageIndex: this.$route.params.pageIndex,
        pageSize: 10
      });
      // console.log(res);
      if (res.Type == "Success") {
        this.visaFlowList = res.Data.list;
        this.IsLogin = res.Data.IsLogin;
        this.CanOperat = res.Data.CanOperat;
        this.total = res.Data.total;
        this.pages = res.Data.pages;
      }
    },
    open() {
      this.visaflowShow = true;
      this.init();
    },
    closeVf() {
      this.visaflowShow = false;
    },
    closeDUpdate() {
      this.dUpdateShow = false;
      this.init(this.pages);
    },
    async showDetails(id) {
      let res = await GetVisaflowDetails({
        id
      });
      // console.log(res);
      if (res.Type == "Success") {
        this.vfDetailsObj = res.Data.visaFlow;
        this.id = id;
        this.vfDetailsShow = true;
      }
    },
    showLargePic(dataList) {
      this.largePicShow = true;
      this.vfDetailsShow = false;
      this.currentImgList = dataList[0].split(",");
      this.activeIndex = dataList[1];
    },
    closeLargePic() {
      this.largePicShow = false;
      this.vfDetailsShow = true;
    },
    update() {
      this.vfDetailsShow = false;
      this.dUpdateShow = true;
    },
    closeVfDetails() {
      this.vfDetailsShow = false;
      this.init(this.pages);
    }
  },
  filters: {
    FlowStatusChange(status) {
      switch (status) {
        case 1:
          return "等待负责人审核";
        case 2:
          return "等待设计部审核";
        case 3:
          return "等待成本部审核";
        case 4:
          return "等待项目负责人审核";
        case 5:
          return "项目负责人已审核";
        case 6:
          return "流程已完成";
      }
    }
  },
  created() {
    this.init();
  },
  // mounted(){
  //   var rou = Math.floor(Math.random()*9000000+1000000);
  //   console.log(rou)
  //   var md = md5(rou + 'userinfo');
  //   console.log(md);
  // }
}
</script>